var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "collapse",
    {
      ref: "collapse",
      staticClass: "nav-drawer",
      attrs: { id: _vm.id, direction: "horizontal" },
      on: { state: _vm.onStateChange }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }